var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BoxContent",on:{"touchmove":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"boxOne"},[_c('svg-btn',{staticClass:"icon",attrs:{"icon-class":"icon-short-no"}}),_c('span',{staticClass:"font1"},[_vm._v("该短链已被系统审核过滤或被分享者删除，无法访问")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }